<template>
  <layout>
    <template v-slot:header>
      <AppHead title="External Order" />
      <div class="admin-header-container">
        <h2 class="mr-3">External Order</h2>
      </div>
    </template>

    <template v-slot:breadcrumbs>
      <BreadCrumbs :activeItem="`MTD Shop - ${mtd.company_name}`" :crumbs="{ home: 'Dashboard' }"/>
    </template>

    <template v-slot:default>
      <div class="row">
       

        <div class="col-md-8 order-1 order-lg-0">
          <card>
            <div class="row">
              <div class="col-12 col-xl-4 mb-3 mb-xl-0">
                <jet-label for="manufacturer_select" value="Manufacturer:" />
                <Multiselect
                  v-model="manufacturerSelected"
                  :options="manufacturers"
                  :searchable="true"
                  class="admin-multiselect"
                  id="manufacturer_select"
                />
              </div>

              <div class="col-12 col-xl-4 mb-3 mb-xl-0">
                <jet-label for="category_select" value="Category:" />
                <Multiselect
                  v-model="categoriesSelected"
                  mode="tags"
                  :options="categories"
                  :searchable="true"
                  class="admin-multiselect"
                  id="category_select"
                />
              </div>

              <div class="col-12 col-xl-4">
                <jet-label for="search" value="Search:" />
                <input type="text" id="search" v-model="searchText" class="form-control" v-focus ref="searchBox">
              </div>

              <div class="col-12 mt-3 d-flex">
                <div class="mr-3 d-flex align-items-center">
                  <label for="active" class="mr-2 mb-0">Active Only:</label>
                  <input type="checkbox" id="active" v-model="searchActive">
                </div>

                <div class="d-flex align-items-center">
                  <label for="active" class="mr-2 mb-0">In Stock Only:</label>
                  <input type="checkbox" id="in_stock" v-model="searchInStock">
                </div>
              </div>
            </div>
          </card>

          <card class="mt-4">
            <DataTable 
              ref="admin-create-mtd-order" :value="products" :paginator="true"
              :lazy="true"
              :first="(pagination.page - 1) * pagination.per_page"
              :rows="pagination.per_page"
              :totalRecords="pagination.total"
              @page="onPage($event)"
              :sortField="sortField"
              :sortOrder="sortOrder"
              @sort="onSort"
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              paginatorPosition="both" :rowsPerPageOptions="[10, 20, 50, 100]"
              class="p-datatable-sm admin-datatable" dataKey="id"
              v-model:selection="selectedProducts"  selectionMode="multiple">
              <template #paginatorLeft>
                {{ products.length }} Products
              </template>
              <Column field="name" header="Name" :sortable="true">
                <template #body="slotProps">
                  {{ slotProps.data.name }}
                  <span v-if="!slotProps.data.is_active" class="badge badge-danger">Inactive</span>
                </template>
              </Column>
              <Column field="inventoryInfo" header="Inventory" :sortable="true" sortField="inventoryInfo.current_inventory">
                <template #body="slotProps">
                  <InventoryInfo :inventoryInfo="slotProps.data.inventoryInfo" />
                </template>
              </Column>
              <Column field="sku" header="SKU" :sortable="true"></Column>
              <Column field="price_wholesale" header="Price (Wholesale)" :sortable="true">
                <template #body="slotProps">
                  {{ formatDollars(slotProps.data.price_wholesale) }}
                </template>
              </Column>
              <Column field="updated_at" header="Last Updated" :sortable="true">
                <template #body="slotProps">
                  {{ moment(slotProps.data.updated_at).format('M/D/YY h:mm A') }}
                </template>
              </Column>
            </DataTable>
          </card>
        </div>

        <div class="col-md-4 order-0 order-lg-1 mb-3 mb-lg-0">
          <Cart :mtdId="mtd.id" 
                :external="true" 
                :selectedProducts="selectedProducts"
                @updateSelectedProducts="updateSelected"></Cart>

  <div class="card">
    <div class="card-header bg-primary text-white">
      <h3 class="mb-0">Address</h3>
    </div>
    <div class="card-body">

      <div class="form-group">
        <label class="mb-1" for="external_reference">External Reference</label>
        <input id="external_reference" class="form-control" type="text" v-model="formPayment.external_reference"/>
        <div v-if="formPayment.errors.external_reference">{{ formPayment.errors.external_reference }}</div>
      </div>      

      <div class="form-group">
        <label for="order_date" class="d-block">Date Placed:</label>
        <Calendar v-model="formPayment.order_date" class="w-100" id="order_date" :showIcon="true" :selectOtherMonths="true"/>
      </div>
      <jet-button class="px-5" btnStyle="success" :disable="formPayment.processing" @click="placeOrder">Enter Order</jet-button>
      <hr/>
      <small>optional - for future use</small>
          <Multiselect
            v-model="formPayment.ship_address_id"
            :options="addresses"
            :searchable="true"
            :canDeselect="false"
            class="admin-multiselect"
            id="addresses_select"
          />

          <jet-add-button @click="showAddress" modalTarget="#addressModal">Add Address</jet-add-button>          



        </div>
      </div>


        </div>
      </div>

      <AddShippingAddress 
        ref="addressForm"
        :states="states"
        @addAddress="addAddress"
        :formAddress="formAddress"
      />

    </template>
  </layout>
</template>

<script>
import Cart from '@/Components/Admin/Cart'
import JetLabel from '@/Jetstream/Label'
import Multiselect from '@vueform/multiselect'
import AppHead from "@/Shared/AppHead";
import Layout from '@/Shared/Admin/Layout'
import FlashMessages from '@/Shared/FlashMessages'
import moment from 'moment'
import BreadCrumbs from '@/Shared/BreadCrumbs'
import JetButton from '@/Jetstream/Button'
import Datatable from 'primevue/datatable'
import Calendar from 'primevue/calendar'
import JetDangerButton from '@/Jetstream/DangerButton'
import JetAddButton from '@/Jetstream/AddButton'
import AddShippingAddress from '@/Components/Modals/AddShippingAddress'
import InventoryInfo from '@/Components/General/InventoryInfo'

export default {
  components: {
    AppHead,
    Cart,
    JetLabel,
    Multiselect,
    JetButton,
    FlashMessages,
    Layout,
    BreadCrumbs,
    Datatable,
    JetAddButton,
    JetDangerButton,
    AddShippingAddress,
    Calendar,
    InventoryInfo,
  },
  props: {
    mtd: Object,
    manufacturers: Array,
    categories: Array,
    addresses: Array,
    states: Array,
    ship_address: Object,
  },
  data() {
    return {
      sortField: null, // current sort field
      sortOrder: null, // current sort order
      pagination: {
        total: 0,
        per_page: 100,
        page: 1,
      },
      manufacturerSelected: null,
      categoriesSelected: null,
      searchText: '',
      searchActive: true,
      searchInStock: false,
      products: [],
      defaultSelectedProductIds: null,
      selectedProducts: [],
      formPayment: this.$inertia.form({
        external_reference: null,
        order_date: null,
        ship_address_id: this.ship_address ? this.ship_address.id : null,
      }),
      formAddress: this.$inertia.form({
        first_name: null,
        last_name: null,
        address1: null,
        address2: null,
        city: null,
        state: null,
        postcode: null,
        email: null,
        phone: null,
        customer_direct_destination: true,
      }),
      formUpdateAddress: this.$inertia.form({
        address_id: null
      }),
    }
  },
  mounted() {
    this.runSearch();
  },
  created() {
    this.moment = moment
  },
  watch: {
    'ship_address.id': function() {
      this.formPayment.ship_address_id = this.ship_address ? this.ship_address.id : null;
    },
    'formPayment.ship_address_id': function() {
      if (this.formPayment.ship_address_id !== null) {
        this.formUpdateAddress.address_id = this.formPayment.ship_address_id;
        this.formUpdateAddress.post(this.route('admin.mtd.checkout.updateShippingAddress', this.mtd.id), {
          preserveScroll: true
        });
      }
    },
    manufacturerSelected() {
      this.runSearch();
    },
    categoriesSelected() {
      this.runSearch();
    },
    searchText() {
      this.runSearch();
    },
    searchActive() {
      this.runSearch();
    },
    searchInStock() {
      this.runSearch();
    },
    defaultSelectedProductIds() {
      this.syncCheckedProducts();
    }
  },
  methods: {
    onSort(events) {
      this.sortField = events.sortField;
      this.sortOrder = events.sortOrder;
      this.runSearch()
    },
    onPage(e) {
      this.pagination.page = e.page + 1
      this.pagination.per_page = e.rows
      this.runSearch()
    },
    runSearch() {
      let data = {
        sort_field: this.sortField,
        sort_order: this.sortOrder,
        query: this.searchText,
        categories: this.categoriesSelected,
        manufacturer_id: this.manufacturerSelected,
        include_inventory: 1,
        filter_instock: this.searchInStock,
        user_id: this.mtd.id,
      };

      if (this.searchActive) {
        data.filter_active = this.searchActive;
      }

      axios
        .post(route('products.search'), data, {
          params: {
            page: this.pagination.page, per_page: this.pagination.per_page
          }
        })
        .then((response) => {
          if (response.data.success) {
            this.products = response.data.data;
            this.pagination.total = response.data.total
            this.syncCheckedProducts();
          }
        });
    },
    showAddress() {
    },
    addAddress() {
      let customer_direct_destination = this.formAddress.customer_direct_destination;

      if (this.formAddress.phone) {
        this.formAddress.phone = this.formAddress.phone.replace(/[^0-9]+/g, '');
      }

      this.formAddress.post(this.route('admin.mtd.checkout.addAddress', this.mtd.id), {
        preserveScroll: true,
        onSuccess: () => {
          $('#addressModal').modal('hide');
          this.filterAddresses();
          this.fetchCheckoutData();
          this.formAddress.reset()
          this.$refs.addressForm.$refs.address1.$el.value = null
          this.formAddress.customer_direct_destination = customer_direct_destination;
        }
      });
    },
    syncCheckedProducts() {
      this.selectedProducts = this.products.filter((product) => this.defaultSelectedProductIds.includes(product.id));
    },
    updateSelected(cartProductIds) {
      this.defaultSelectedProductIds = cartProductIds

      this.$refs.searchBox.focus();
      this.$refs.searchBox.select();
    },
    placeOrder() {
      this.formPayment.post(this.route('admin.amazon.order', this.mtd.id));
    }
  },
  directives: {
    focus: {
      // directive definition
      mounted(el) {
        el.focus();
        el.select();
      }
    }
  },
}

</script>

<style src="@vueform/multiselect/themes/default.css"></style>
